<template>
	<div style="min-width: 500px;">
		<div v-html="$t('reinvite_e_mail', { email: targetEmail })"></div>
		<div class="flex justify-end mt-3">
			<BaseButton class="btn-blue" @click="send" v-bind="$attrs" :is-loading="isLoading">
				{{ $t('invite').toString() }}
			</BaseButton>
		</div>
	</div>
</template>
<script>
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import InvitationsRepository from '@/api/repositories/InvitationsRepository';

export default {
	name: 'InviteResendModal',
	components: { BaseButton },
	data() {
		return {
			isLoading: false,
			targetEmail: '',
		};
	},
	mounted() {
		this.targetEmail = this.$route.query.email;
	},
	methods: {
		send() {
			this.isLoading = true;
			const id = this.$route.params.id;
			if (id) {
				new InvitationsRepository()
					.resendInvitation(id)
					.then(response => {
						this.isLoading = false;
						this.$swal({
							title: this.$t('general.success'),
							text: this.$t('invite_send_successfully'),
							icon: 'success',
						}).then(response => {
							this.$router.back();
						});
					})
					.catch(error => {
						this.isLoading = false;
						this.$swal({
							title: this.$t('general.error'),
							text: this.$t('invite_send_failed'),
							icon: 'error',
						}).then(response => {
							//this.$router.back();
						});
					});
			}
		},
	},
};
</script>